import { Button, Col, Form, Row, Tooltip } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { LikeFilled, LikeOutlined, DislikeFilled, DislikeOutlined } from '@ant-design/icons';

// Add this CSS to your global stylesheet or use a CSS-in-JS solution
// .pop-animate { animation: pop 0.2s; }
// @keyframes pop { 0% { transform: scale(1); } 50% { transform: scale(1.3); } 100% { transform: scale(1); } }

const LikeBtn = ({
    form,
    name,
    label,
    defaultValue,
    containerStyle = {}

}) => {
    const [val, setVal] = useState(defaultValue || null);
    const [anim, setAnim] = useState(null); // 'like' or 'unlike'
    const audioRef = useRef(null);

    useEffect(() => {
        onAction(defaultValue);
        // Preload audio
        audioRef.current = new Audio(require(`../assets/audio/likeSound.mp3`));
        audioRef.current.load();
        // eslint-disable-next-line
    }, []);


    const onAction = (value) => {
        form.setFieldValue(name, value);
        setVal(value);
    };

    const playAudio = () => {
        if (audioRef.current) {
            audioRef.current.currentTime = 0;
            audioRef.current.play();
        }
    };

    // Handle animation reset
    const handleClick = (type, value) => {
        playAudio();
        onAction(value);
        setAnim(type);
        setTimeout(() => setAnim(null), 200); // match animation duration
    };

    return (
        <>
            <Row className='ant-form-item-row'>
                <Col span={24} className='ant-form-item-label'>
                    <label className='ant-form-item-no-colon' title={label}>{label}</label>
                </Col>
            </Row>
            <div style={{ ...containerStyle }}>
                <Form.Item name={name} hidden />
                <Tooltip title="Like" color="blue">
                    <Button
                        style={{ marginRight: 10 }}
                        onClick={() => handleClick('like', 1)}
                        type="link"
                        className={anim === 'like' ? 'pop-animate' : ''}
                        icon={
                            val === 1 ?
                                <LikeFilled style={{ fontSize: 35 }} /> :
                                <LikeOutlined style={{ fontSize: 35 }} />
                        }
                    >{''}</Button>
                </Tooltip>
                <Tooltip title="Unlike" color="blue">
                    <Button
                        onClick={() => handleClick('unlike', 0)}
                        type="link"
                        className={anim === 'unlike' ? 'pop-animate' : ''}
                        icon={
                            val === 0 ?
                                <DislikeFilled style={{ fontSize: 35 }} /> :
                                <DislikeOutlined style={{ fontSize: 35 }} />
                        }
                    >{''}</Button>
                </Tooltip>
            </div>
        </>
    )
};


export default LikeBtn;